import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
    buttonsearch: {
        height: '32px',
        width: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f2f2f2',
        cursor: 'pointer',
        border: '2px solid #028B7E',
        borderRadius: '23px',
        '&:hover': {
          backgroundColor: '#fff'
        },
        '@media all and (max-width: 600px)': {
          height: '28px',
          width: '135px',
        },
      },
      searchIconButton: {
        fontSize: '1.5em',
        color: '#028B7E',
        '@media all and (max-width: 600px)': {
          fontSize: 11,
        },
      },
      typographyButton: {
        paddingLeft: 5,
        fontFamily: 'Raleway',
        fontSize: 14.5,
        letterSpacing: '0.05em',
        color: '#028B7E',
        '@media all and (max-width: 600px)': {
          fontSize: 11,
          paddingLeft: 2,
        },
      },
      boxModal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '350px',
        background: '#fff',
        borderRadius: '8px'
      },
      buttons: {
        position: 'absolute',
        bottom: 18,
        display: 'flex',
        justifyContent: 'flex-end',
        width: '90%'
      },
      confirmButton: {
        width: 120,
        height: 35,
        marginLeft: '10px',
        cursor: 'pointer',
        borderRadius: '23px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // '&:hover': {
        //   backgroundColor: '#1BF57F'
        // }
      },
      confirmButtonDisabled: {
        width: 120,
        height: 35,
        marginLeft: '5%',
        backgroundColor: '#BDBEBF',
        // boxShadow: '0px 0px 1px 0px rgba(0,0,0,0.50)',
        // WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
        // MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
        borderRadius: '23px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      confirmButtonTypography: {
        color: '#FFFFFF',
        fontSize: 14,
        fontFamily: 'Raleway',
        fontWeight: 700,
        fontStyle: 'normal',
        letterSpacing: '0.05em',
        lineHeight: '21px'
      },
      closeButton: {
        width: 90,
        height: 35,
        backgroundColor: '#FFFFFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#263057',
        cursor: 'pointer',
        fontSize: 16,
        '&:hover': {
          color: '#1BF57F'
        },
        fontWeight: 700,
        fontFamily: 'Raleway',
        fontStyle: 'normal',
        lineHeight: '23px'
      },

}))

export default useStyles
